import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

const products = [
  {
    id: 1,
    name: 'Diamond Necklace',
    image: 'https://tse3.mm.bing.net/th/id/OIP.1x_bdLYvbaH72KrnhZj-LgHaHa?w=626&h=626&rs=1&pid=ImgDetMain&o=7&rm=3',
    description: 'Stunning diamond necklace featuring a cascade of brilliant-cut diamonds set in 18K white gold. Perfect for special occasions.',
    material: '18K White Gold',
    craftsmanship: 'Pave Setting'
  },
  {
    id: 2,
    name: 'Gold Choker',
    image: 'https://www.jaebee.com/cdn/shop/products/ali_N803_gold_layered_choker_1024.png?v=1635024206&width=1000',
    description: 'Traditional gold choker with intricate filigree work. Handcrafted in 22K gold, this piece adds elegance to any outfit.',
    material: '22K Yellow Gold',
    craftsmanship: 'Filigree'
  },
  {
    id: 3,
    name: 'Pearl Necklace',
    image: 'https://tse4.mm.bing.net/th/id/OIP.O4moRrhz7q4Utra9PTVvNQHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
    description: 'Elegant freshwater pearl strand with a 14K gold clasp. Each pearl is carefully selected for its lustre and uniformity.',
    material: 'Freshwater Pearl, 14K Gold',
    craftsmanship: 'Hand-String'
  },
  {
    id: 4,
    name: 'Emerald Pendant',
    image: 'https://i.etsystatic.com/10007272/r/il/ff519e/770565240/il_fullxfull.770565240_pp4x.jpg',
    description: 'Stunning emerald pendant surrounded by diamonds, set in 18K white gold. The vibrant green emerald is of excellent clarity.',
    material: '18K White Gold, Emerald',
    craftsmanship: 'Prong Setting'
  },
  {
    id: 5,
    name: 'Ruby Necklace',
    image: 'https://eragem.com/media/catalog/product/cache/1/image/17f82f742ffe127f42dca9de82fb58b1/1/7/17478a.jpg',
    description: 'Vibrant ruby necklace with a floral design, set in 18K yellow gold. The rubies are heat-treated for deep color.',
    material: '18K Yellow Gold, Ruby',
    craftsmanship: 'Hand-Engraved'
  },
  {
    id: 6,
    name: 'Sapphire Necklace',
    image: 'https://tse2.mm.bing.net/th/id/OIP.sjAfSL1PLcVtF_nGT2oN2gHaIJ?rs=1&pid=ImgDetMain&o=7&rm=3',
    description: 'Elegant sapphire pendant with a halo of diamonds, set in platinum. The deep blue sapphire is certified natural.',
    material: 'Platinum, Sapphire',
    craftsmanship: 'Micro Pave'
  },
];

const Necklaces = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [failedImages, setFailedImages] = useState({});
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setSelectedProduct(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleImageError = (id) => {
    setFailedImages((prev) => ({ ...prev, [id]: true }));
  };

  const handleViewDetails = (product) => {
    setSelectedProduct(product);
  };

  return (
    <div className="min-h-screen bg-white text-stone-800 p-8">
      <div className="text-sm text-stone-500 mb-4">
        <Link to="/shop" className="hover:text-amber-600 transition-colors">Shop</Link> / <span className="text-stone-800 font-medium">Necklaces</span>
      </div>

      <h1 className="text-4xl font-bold mb-6">Necklaces</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {products.map((product) => {
          const imageFailed = failedImages[product.id];
          return (
            <div
              key={product.id}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden border border-stone-200"
            >
              <div className="aspect-square overflow-hidden bg-stone-100">
                {!imageFailed ? (
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    onError={() => handleImageError(product.id)}
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full bg-amber-100 flex items-center justify-center">
                    <span className="text-stone-800 text-xs text-center px-1">{product.name}</span>
                  </div>
                )}
              </div>
              <div className="p-2">
                <h3 className="text-sm font-semibold text-stone-800 mb-1 truncate">{product.name}</h3>
                <button
                  onClick={() => handleViewDetails(product)}
                  className="w-full py-1.5 text-xs border border-amber-500 text-amber-600 rounded hover:bg-amber-500 hover:text-white transition-colors duration-300 font-medium"
                >
                  View Details
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {selectedProduct && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div
            ref={modalRef}
            className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
          >
            <div className="relative">
              <button
                onClick={() => setSelectedProduct(null)}
                className="absolute top-4 right-4 text-stone-500 hover:text-stone-800 transition-colors z-10"
              >
                <FaTimes size={24} />
              </button>
              <div className="p-6">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="md:w-1/2">
                    <img
                      src={selectedProduct.image}
                      alt={selectedProduct.name}
                      className="w-full h-auto object-cover rounded-xl shadow-md"
                    />
                  </div>
                  <div className="md:w-1/2">
                    <h2 className="text-2xl font-bold text-stone-800 mb-2">{selectedProduct.name}</h2>
                    <p className="text-stone-600 mb-4">{selectedProduct.description}</p>
                    <div className="space-y-2">
                      <p className="text-sm text-stone-500">
                        <span className="font-medium">Material:</span> {selectedProduct.material}
                      </p>
                      <p className="text-sm text-stone-500">
                        <span className="font-medium">Craftsmanship:</span> {selectedProduct.craftsmanship}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Necklaces;